<template>
  <div class="page-content" id="writeOffDetails">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>窜货结算</el-breadcrumb-item>
        <el-breadcrumb-item>核销明细</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="打款日期" :label-width="formLabelWidth">
            <el-date-picker v-model="searchformDate" type="daterange" start-placeholder="开始日期" value-format="yyyy-MM-dd"
              end-placeholder="结束日期" range-separator="~" size="small">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否转寄" :label-width="formLabelWidth">
            <el-select v-model="queryParams.forwardstatus" filterable clearable placeholder="请选择" size="small">
              <el-option v-for="item in zhuanjiLIst" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品码" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="queryParams.productcodes" autocomplete="on" size="small"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="快递单号" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="queryParams.expressnumber" autocomplete="on" size="small"
              clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
      <div class="page">
        <div class="downBtn" style="margin-bottom: 8px;">
          <el-button size="small" type="primary" @click="downLoadDataClick" :loading="LoadData">下载数据</el-button>
          <el-button size="small" @click="newAdd()" v-if="logintype == 'KEFU'">批量转寄</el-button>
          <el-button size="small" @click="orderAll()" v-if="logintype == 'KEFU'">批量结算</el-button>
        </div>
        <el-table :data="tableData" ref="multipleTable" v-loading="dataLoading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" @row-click="detailsDrawer" style="width: 100%;"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" fixed :selectable="checkSelectable">
          </el-table-column>
          <el-table-column label="是否转寄">
            <template slot-scope="scope">
              {{ scope.row.forwardstatus == '1' ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="是否结算">
            <template slot-scope="scope">
              {{ scope.row.settlementstatus == '1' ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="提报编号" width="140">
            <template slot-scope="scope">
              <div style="width: 126px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.chnumbers }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="产品码" width="200">
            <template slot-scope="scope">
              <div style="width: 173px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.product_codes }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="邮寄产品总数" prop="product_total_count">
          </el-table-column>
          <el-table-column label="实际购买总价（元）" prop="purchase_total_price">
          </el-table-column>
          <el-table-column label="云仓选择" prop="cloud_warehouse_name">
          </el-table-column>
          <el-table-column label="寄件人" prop="consignee_name">
          </el-table-column>
          <el-table-column label="联系电话" prop="contact_phone">
          </el-table-column>
          <el-table-column label="快递单号" width="200">
            <template slot-scope="scope">
              <div style="width: 175px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{ scope.row.express_number }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="快递费（元）" prop="express_fee">
          </el-table-column>
          <el-table-column label="快递费凭证" width="100px">
            <template slot-scope="scope">
              <div v-for="(item) in scope.row.express_fee_pz.split(',')" style="width: 100px;float: left;">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;">
                </img>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="开户人姓名" prop="account_holder_name">
          </el-table-column>
          <el-table-column label="银行账号" prop="bank_account">
          </el-table-column>
          <el-table-column label="开户行名称" prop="bank_name">
          </el-table-column>
          <el-table-column label="核销金额（含快递费）">
            <template slot-scope="scope">
              {{ Number(scope.row.priceSum) }}
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remake">
          </el-table-column>
          <el-table-column label="打款金额" prop="operation_price">
          </el-table-column>
          <el-table-column label="打款凭证">
            <template slot-scope="scope">
              <div v-for="(item) in scope.row.operation_remark.split(',')" style="width: 100px;float: left;">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;">
                </img>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="打款人" prop="operator_name">
          </el-table-column>
          <el-table-column label="打款时间" prop="dcreatetime">
          </el-table-column>
        </el-table>
        <div v-show="this.tableData.length > 0">
          <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
            @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
          </pagination>
        </div>
        <!-- 新增 -->
        <el-dialog title="批量转寄" :visible.sync="downDataDialog" :close-on-click-modal="false" width="640px">
          <el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
            <div class="seaerch-wrapper">
              <el-form label-width="135px">
                <el-form-item label="提报编号：">
                  <div v-if="downData.chnumbers && downData.chnumbers.length > 0">
                    <div v-for="a in downData.chnumbers.split(',')">
                      {{ a }}
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="产品码：">
                  <div v-if="downData.productcodes && downData.productcodes.length > 0">
                    <div v-for="a in downData.productcodes.split(',')">
                      {{ a }}
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="转寄产品总数：">
                  {{ downData.forwardproductTotalCount }}
                </el-form-item>
                <el-form-item label="转寄打款金额：">
                  {{ downData.forwardoperationPrice }}
                </el-form-item>
                <el-form-item label="转寄日期：" :required="true">
                  <el-date-picker v-model="downData.forwardtime" type="date" style="width: 394px;" size="small"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="转寄快递单号：">
                  <el-input placeholder="请输入" v-model="downData.forwardexpressNumber" v-limitInput size="small"
                    clearable></el-input>
                </el-form-item>
                <el-form-item label="转寄快递费：">
                  <el-input placeholder="请输入" v-model="downData.forwardexpressFee" v-limitInput size="small"
                    type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="转寄快递费凭证：">
                  <el-upload class="avatar-uploader" action="/hcm/hcmWorkOrder/headImgUploadPRS"
                    list-type="picture-card" :file-list="fileList" :before-upload="beforeUpload" :limit="9"
                    :on-exceed="handleExceed" :on-success="handleUploadSuccess" :on-remove="handleRemove"
                    accept="image/png, image/jpg" multiple ref="elUploadWriteOffDetails">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
          <span slot="footer">
            <el-button size="small" class="g-confirm-btn" :loading="downloadLoading" @click="determine" type="primary">确
              定</el-button>
            <el-button size="small" class="g-cancel-btn" @click="downDataDialog = false">取 消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <el-drawer title="核销详情" :visible.sync="drawer" size="840px">
      <el-card class="margin_bottom20 no_margin">
        <el-form label-width="160px">
          <el-form-item label="提报编号：">
            <div v-if="detilData.chnumbers">
              <div v-for="a in detilData.chnumbers.split(',')">
                {{ a }}
              </div>
            </div>

          </el-form-item>
          <el-form-item label="产品码：">
            <div v-if="detilData.productCodes">
              <div v-for="a in detilData.productCodes.split(',')">
                {{ a }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="邮寄产品总数：">
            <span>{{ detilData.productTotalCount }}</span>
          </el-form-item>
          <el-form-item label="实际购买总价（元）：">
            <span>{{ detilData.purchaseTotalPrice }}</span>
          </el-form-item>
          <el-form-item label="云仓选择：">
            <span>{{ detilData.cloudWarehouseName }}</span>
          </el-form-item>
          <el-form-item label="寄件人：">
            <span>{{ detilData.consigneeName }}</span>
          </el-form-item>
          <el-form-item label="联系电话：">
            <span>{{ detilData.contactPhone }}</span>
          </el-form-item>
          <el-form-item label="快递单号：">
            <div v-if="detilData.expressNumber">
              <div v-for="a in detilData.expressNumber.split(',')">
                {{ a }}
              </div>
            </div>

          </el-form-item>
          <el-form-item label="快递费（元）：">
            <span>{{ detilData.expressFee }}</span>
          </el-form-item>
          <el-form-item label="快递费凭证：">
            <div v-if="detilData.expressFeePz">
              <div v-for="(item) in detilData.expressFeePz.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;cursor: pointer;">
                </img>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="开户人姓名：">
            <span>{{ detilData.accountHolderName }}</span>
          </el-form-item>
          <el-form-item label="银行账号：">
            <span>{{ detilData.bankAccount }}</span>
          </el-form-item>
          <el-form-item label="开户行名称：">
            <span>{{ detilData.bankName }}</span>
          </el-form-item>
          <el-form-item label="核销金额（含快递费）:">
            <span>{{  detilData.priceSum }}</span>
          </el-form-item>
          <el-form-item label="备注：">
            <span>{{ detilData.remake }}</span>
          </el-form-item>
          <el-form-item label="打款金额：">
            <span>{{ reportInfoVerification.operationPrice }}</span>
          </el-form-item>
          <el-form-item label="打款凭证：">
            <div v-if="reportInfoVerification.operationRemark">
              <div v-for="(item) in reportInfoVerification.operationRemark.split(',')" style="width: 100px;float: left;"
                @click="jump(item)">
                <img :src="item" style="height: 80px;margin-right: 10%;margin-top: 20rpx;">
                </img>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="打款人：">
            <span>{{ reportInfoVerification.operatorName }}</span>
          </el-form-item>
          <el-form-item label="打款时间：">
            <span>{{ reportInfoVerification.dcreatetime }}</span>
          </el-form-item>
        </el-form>
      </el-card>
    </el-drawer>
    <!--批量备注-->
    <el-dialog title="批量结算" :visible.sync="orderShow" width="360px" height="278" size="small">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="结算状态：" :label-width="formLabelWidth">
          <el-select v-model="settlementstatus" filterable placeholder="请选择" size="small">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="orderSure">确 定</el-button>
        <el-button @click="orderShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "../../components/dataTable/pagination";
import { getLoginType } from "@/libs/until";
import axios from 'axios'
export default {
  data() {
    return {
      reportInfoVerification: {},
      queryParams: {
        forwardstatus: '',
        productcodes: '',
        expressnumber: '',
      },
      imageUrl: '',
      allNumber: 0,
      reportpicArr: [],
      drawer: false,
      fileList: [],
      LoadData: false,
      downDataDialog: false,
      downloadLoading: false,
      downData: {
        chnumbers: null,
        productcodes: null,
        forwardproductTotalCount: null,
        forwardoperationPrice: null,
        forwardtime: null,
        forwardexpressNumber: null,
        forwardexpressFee: null,
        forwardexpressFeePz: [],
        ids: [],
      },
      dataLoading: false,
      pageNo: 1,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      searchformDate: [],
      totalNum: 100,
      formLabelWidth: '100px',
      detilData: {},
      zhuanjiLIst: [{
        name: '是',
        value: '1'
      }, {
        name: '否',
        value: '0'
      }],
      logintype: getLoginType(),
      multipleSelection: [],
      orderShow: false,
      settlementstatus: '0',
    }
  },
  mounted() {
    this.theQuery()
  },
  methods: {
    orderAll() {
      this.orderShow = true
    },
    orderSure() {
      let data = {
        ids: this.multipleSelection.map(item => item.id).join(','),
        settlementstatus: this.settlementstatus,
      }
      let that = this;
      axios({
        method: 'post',
        url: 'hcm/HcmReportInfoShipping/updateSettlementstatus',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        },
        params: data,
      }).then(function (response) {
        if (response.data.status == "10000") {
          that.orderShow = false
          // that.downloadLoading = false
          that.$message({
            type: "success",
            message: "成功!"
          });
          that.theQuery()
        } else {
          that.orderShow = false
          // that.downloadLoading = false
          that.$message.error(response.data.message)
        }
      })
    },
    // 控制选择框是否可用的方法
    checkSelectable(row, index) {
      // 当 forwardstatus 为 '1' 时，禁用选择（返回false）
      return row.forwardstatus !== '1';
    },
    jump(url) {
      window.open(url)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多允许上传 9 张图片，您已选择了 ${fileList.length} 张，无法继续上传。`);
    },
    // 序号勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 详情
    detailsDrawer(row) {
      this.detilData = {}
      let params = {
        id: row.id
      }
      fetch({
        url: "hcm/HcmReportInfoShipping/findById",
        method: "get",
        noFormat: true,
        params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        if (res.status == '10000') {
          this.detilData = res.data.hcmReportInfoShipping;
          this.reportInfoVerification = res.data.reportInfoVerification;
          this.drawer = true
        }
      }).catch(err => {

      })

    },
    // 新增确定
    determine() {
      if (!this.downData.forwardtime) {
        this.$message({
          message: '请选择转寄时间',
          type: 'warning'
        });
        return
      }
      this.downloadLoading = true
      this.downData.forwardexpressFeePz = this.fileList.join(',')
      let that = this
      axios({
        method: 'post',
        url: 'hcm/HcmReportInfoForward/saveReportInfoForward',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        },
        params: that.downData,
      }).then(function (response) {
        if (response.data.status == "10000") {
          that.downDataDialog = false
          // that.downloadLoading = false
          that.$message({
            type: "success",
            message: "成功!"
          });
          that.theQuery()
        } else {
          that.downDataDialog = false
          // that.downloadLoading = false
          that.$message.error(response.data.message)
        }
      })
    },
    // 删除图片
    handleRemove(file, fileList) {
      if (file.response) {
        const urlToRemove = file.response.data.data;
        this.fileList = this.fileList.filter(url => url !== urlToRemove);
      }
    },
    handleUploadSuccess(res) {
      this.fileList.push(res.data.data)
    },
    beforeUpload(file) {
      let name = file.name;
      let p = /\.(jpg|png)$/
      if (!p.test(name)) {
        this.$message({
          showClose: true,
          message: '请上传符合要求格式的文件',
          type: 'warning'
        });
      }
      let limitSize = 1 * 1024 * 1024 * 50;
      if (file.size > limitSize) {
        this.$message({
          showClose: true,
          message: '请上传大小小于50M的文件',
          type: 'warning'
        });
      }
      if (this.fileList.length >= 9) {
        this.$message.warning('已达最大上传数量（9张），无法继续上传。');
        return false;
      }
      if (p.test(name) && file.size < limitSize) {
        return true;
      }
      return false;
    },
    // 下载数据
    downLoadDataClick() {
      this.LoadData = true
      let params = {
        ...this.queryParams
      }
      if (this.searchformDate && this.searchformDate.length == 2) {
        params.starttime = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10)
        params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10)
      }
      fetch({
        url: "/hcm/HcmReportInfoShipping/findPageReportInfoShippingBmcDownload",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "blob"
      })
        .then((res) => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '核销明细.xlsx')
          document.body.appendChild(link)
          link.click()
          this.LoadData = false
        })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = `${val}`
      this.theQuery()
    },
    // 翻页
    handleSizeChange(val) {
      this.pageSize = `${val}`
      this.theQuery()
    },
    // 数据源
    theQuery() {
      this.dataLoading = true
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.queryParams
      }
      if (this.searchformDate && this.searchformDate.length == 2) {
        params.starttime = this.$options.filters['fullTime'](this.searchformDate[0]).substring(0, 10)
        params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]).substring(0, 10)
      }
      fetch({
        url: "hcm/HcmReportInfoShipping/findPageReportInfoShippingBmc",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.dataLoading = false
          this.tableData = res.data.content
          this.totalNum = res.data.totalElements
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 新增
    newAdd() {
      if (this.multipleSelection == 0) {
        this.$message({
          message: '请选择一条数据',
          type: "warning"
        });
        return;
      }
      this.downData = {
        chnumbers: null,
        productcodes: null,
        forwardproductTotalCount: null,
        forwardoperationPrice: null,
        forwardtime: null,
        forwardexpressNumber: null,
        forwardexpressFee: null,
        forwardexpressFeePz: null,
        ids: [],
      }
      let arrCode = []
      let arrCode2 = []
      for (let a in this.multipleSelection) {
        this.downData.ids.push(this.multipleSelection[a].id)
        const codesArray = this.multipleSelection[a].product_codes.split(',');
        const codesArray2 = this.multipleSelection[a].chnumbers.split(',');
        arrCode.push(...codesArray);
        arrCode2.push(...codesArray2);
        // this.downData.productcodes += this.multipleSelection[a].product_codes + ','
        this.downData.forwardproductTotalCount += Number(this.multipleSelection[a].product_total_count)
        this.downData.forwardoperationPrice += Number(this.multipleSelection[a].operation_price)
      }
      this.downData.productcodes = arrCode.join(',');
      this.downData.chnumbers = arrCode2.join(',');

      this.downData.ids = this.downData.ids.join(',');
      this.downDataDialog = true
    },
  },
  components: {
    pagination
  }
}
</script>
<style lang="scss">
#writeOffDetails {
  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  .el-table th {
    background-color: #f2f6fe !important;
    color: #4a4b4c;
  }

  .page {
    padding: 20px;
    margin: 10px 0px 0px 0px;
    background-color: white;
  }

  #dialog {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }

    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }

  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }

  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

  .downBtn {
    display: flex;
    justify-content: flex-start;
  }

  .threeHa {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
